import React, { useEffect, useState } from 'react';
import Universalpageheader from '../Headers/universalpageheader';
import Productcard from '../Products/productcard';
import { Button, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Searchbar from '../Components/searchbar';
import constants from "./../Utils/constants.json"
import { removeFromStore } from '../Utils/fn';
import Errorcomponent from '../Components/errorcomponent';
import { setAlert } from '../../store/alert';
import { setRecentlySearched } from '../../store/recentlySearched';


function Recentlysearchedpage() {
    const dispatch = useDispatch();
    const subProducts = useSelector((state) => state.subProducts.data);
    const recentlySearched = useSelector((state) => state.recentlySearched.data);

    const [loading, setloading] = useState(false);
    const [showsearchbar, setshowsearchbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    function clearRecentlySearched() {
        dispatch(setRecentlySearched(null));
        removeFromStore(constants.RECENTLY_SEARCHED);
        dispatch(setAlert({ type: 'success', message: 'Recently searched cleared' }));
    }


    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalpageheader onshowsearch={() => setshowsearchbar(true)} pagename={"Last Searched"} withbackicon={true} />
            {loading && <div className='mainloadingdiv'><CircularProgress /></div>}
            <div >
                <div className='wrapfourcards' style={{ height: "80%" }}>
                    {recentlySearched?.map((val, key) => {
                        return (
                            <Productcard product={val} key={key} showoffer={true} />
                        )
                    })}
                </div>
                {recentlySearched?.length < 1 || !recentlySearched && <Errorcomponent error={"No recently searched items"} />}
                {recentlySearched?.length > 0 &&
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Button onClick={() => clearRecentlySearched()}>CLEAR ALL</Button>
                    </div>
                }
            </div>
        </div>
    );
}


export default Recentlysearchedpage;
